/**
 * @generated SignedSource<<4f68a86ed8d0078bb464653dd9101fc7>>
 * @relayHash aa6e7129852fe4fec6b4fc5c1e941ad2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 064c17d742eca71a86d08378310a392d3a6f2cf4ad7d4607bdbd911cebcf65d0

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UsageFilters = {
  aggregationStep?: any | null | undefined;
  alignPeriodWithAggregationStep?: boolean | null | undefined;
  approximateNumberOfDataPoints?: number | null | undefined;
  from?: string | null | undefined;
  graphSlug?: string | null | undefined;
  isCustomRange?: boolean | null | undefined;
  range?: any | null | undefined;
  to: string;
};
export type graphUsagePageQuery$variables = {
  account: string;
  filters: UsageFilters;
};
export type graphUsagePageQuery$data = {
  readonly accountBySlug: {
    readonly " $fragmentSpreads": FragmentRefs<"usageDataFragment">;
  };
};
export type graphUsagePageQuery = {
  response: graphUsagePageQuery$data;
  variables: graphUsagePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "account"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "account"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestsCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "graphUsagePageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "accountBySlug",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "usageDataFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "graphUsagePageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isAccount"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "filters",
                "variableName": "filters"
              }
            ],
            "concreteType": "AccountUsageTimeSeries",
            "kind": "LinkedField",
            "name": "usage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UsageMetricsTimeSeriesDataPoint",
                "kind": "LinkedField",
                "name": "points",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateTime",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UsageMetrics",
                "kind": "LinkedField",
                "name": "overall",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aa6e7129852fe4fec6b4fc5c1e941ad2",
    "id": "064c17d742eca71a86d08378310a392d3a6f2cf4ad7d4607bdbd911cebcf65d0",
    "metadata": {},
    "name": "graphUsagePageQuery",
    "operationKind": "query",
    "text": "query graphUsagePageQuery(\n  $account: String!\n  $filters: UsageFilters!\n) {\n  accountBySlug(slug: $account) {\n    __typename\n    ...usageDataFragment\n    id\n  }\n}\n\nfragment usageDataFragment on Account {\n  __isAccount: __typename\n  usage(filters: $filters) {\n    points {\n      requestsCount\n      dateTime\n    }\n    overall {\n      requestsCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e290f0fe70800828f759c87c77c1cb70";

export default node;
